// @flow

import type {Effect} from '../../types'

import {
  take,
  put,
} from 'redux-saga/effects'
import {
  actions as routerActions,
} from 'redux-router5'

import {mapActions} from '../actions'

export function* searchByTextEffect(): Effect {
  while (true) {
    const {payload: {text}} = yield take(mapActions.searchByText.id)
    yield put(routerActions.navigateTo('place-list', {'q': text}))
  }
}
